import { Goal } from "../types/goal-parameters";

export const safeNumber = (
  value: string | number | null | undefined,
  max?: string | number | null,
): number => {
  const num = Number(value);

  if (!Number.isFinite(num) || num < 0) {
    return 0;
  }

  if (max === undefined) {
    return num; // no cap requested
  }

  const cap = Number(max);
  if (!Number.isFinite(cap) || cap < 0) {
    return 0;
  }

  return Math.min(num, cap);
};

export const getGoalParameters = (goal: Goal) => [
  {
    name: "Health Awareness Sessions",
    target: safeNumber(goal.health_camps_target),
    achieved: safeNumber(goal.health_camps_actual, goal.health_camps_target),
    unit: "Sessions",
    extra: "",
  },
  {
    name: "Individuals Registered in the Portal",
    target: safeNumber(goal.health_camps_attendees_target),
    achieved: safeNumber(
      goal.health_camps_attendees_actual,
      goal.health_camps_attendees_target,
    ),
    unit: "Individuals",
    extra: "",
  },

  {
    name: "Membership Subscription Weightage",
    target: safeNumber(goal.subscription_weightage_target),
    achieved: safeNumber(
      goal.subscription_weightage_actual,
      goal.subscription_weightage_target,
    ),
    unit: "Points",
  },

  {
    name: "Health Checkups Conducted",
    target: safeNumber(goal.health_checkup_target),
    achieved: safeNumber(goal.health_checkup_actual),
    unit: "Checkups",
    extra: "",
  },

  {
    name: "Health Reports Updated in the Portal",
    target: safeNumber(goal.health_reports_added_target),
    achieved: safeNumber(goal.health_reports_added_actual),
    unit: "Reports",
  },

  {
    name: "Supplement Amount Completed",
    target: safeNumber(goal.supplements_order_target),
    achieved: safeNumber(
      goal.supplements_order_actual,
      goal.supplements_order_target,
    ),
    unit: "₹",
  },
];